// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jwV-","top":"styles_top__2q0S8"};